import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaSortingDropDown'

type IcaSortingDropDownProps = React.JSX.IntrinsicElements['tgdb-ica-sorting-drop-down']

export const IcaSortingDropDown = wrapWc<IcaSortingDropDownProps & {
  onSortingchanged?: (e: CustomEvent) => void
  onClose?: (e: CustomEvent) => void
}>('tgdb-ica-sorting-drop-down', ['sortingchanged', 'close'])